module.exports = __webpack_public_path__ + "img/advice2.14b412cf.png";